import { RootState } from 'store';

const SahServiceTypeAssociationsState = (state: RootState) => state.supportAtHome.sahServiceTypeAssociations;

export const selectSahServiceTypeAssociations = (state: RootState) => SahServiceTypeAssociationsState(state).rows;
export const selectSahServiceTypeAssociationsTotal = (state: RootState) => SahServiceTypeAssociationsState(state).total;
export const selectLoading = (state: RootState) => SahServiceTypeAssociationsState(state).loading;
